<template>
	<section>
		<header-page
			actions
			name="costs-centers"
			:title="title"
			@run-action="runAction"
		/>
		<app-actions
			:resource-uri="$route.name"
			@run-action="runAction"
		/>
		<backButtonRoute/>
		<!-- <cost-center-list
			:columns="columns"
			:items-total-quantity="table.itemTotal"
			:items-quantity="table.rows.length"
			:current-page="currentPage"
			:rows="table.rows"
			:last-page="table.lastPage"
			@click-icon="onClickIcon"
			@on-page="changePage"
			@on-search="onSearchTable"
		/> -->
		<tree-table
			:tree-data="costCenters"
			@click-icon="onClickIcon"></tree-table>
		<action-bar
			class="action-mobile"
			:resource-uri="$route.name"
			@run-action="runAction"
		/>
		<v-dialog
			content-class="confirmation-dialog"
			v-model="dialog"
			max-width="400"
		>
			<v-card class="pa-4">
				<v-card-text class="title text-xs-center pt-4">
					{{ dialogMessage }}<br>
					<p style="font-size: small; color: red;">¡Tenga en cuenta que el Centro de Costos puede tener datos asociados!</p>
				</v-card-text>
				<v-card-actions class="justify-center pb-4">
					<v-btn
						type="button"
						@click="closeDialog"
						color="success"
						:disabled="loading"
						class="btn-action mr-1 white--text">
						Cancelar
					</v-btn>
					<v-btn
						type="button"
						color="error"
						@click="onDelete"
						:disabled="loading"
						class="btn-action ml-1 white--text">
						Eliminar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<router-view></router-view>
	</section>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex';
	import actionBar from '@/components/shared/action-bar/action-bar';
	import backButtonRoute from '@/components/shared/back-button-route';
	import costCenterList from '@/components/cost-centers/cost-center-list';
	import { COSTS_CENTERS, COSTS_CENTERS_EDIT, COSTS_CENTERS_NEW } from '@/shared/action-codes';
	import appActions from '@/components/shared/app-actions/app-actions';
	import appTooltipButton from '@/components/shared/app-tooltip-button';
	import treeTable from '@/components/shared/tree-table';

	async function created() {
		if (this.currentSubsidiary) {
			this.loadCostC();
			// this.loadData(`cost-center/${this.currentSubsidiary.id}/subsidiary`,
			// { params: this.params });
		}
	}

	async function changePage(page) {
		this.currentPage = page;
		this.params.page = page;
		this.loadCostC();
	}

	function closeDialog() {
		this.dialog = false;
		this.dialogMessage = '';
		this.costCenterId = null;
	}

	function onClickIcon(action, row) {
		if (action === 'edit') {
			this.goTo(COSTS_CENTERS_EDIT,
				{ params: { id: row.id, isEdit: true }, query: this.$route.query });
		} else if (action === 'delete') {
			this.openConfirmation({ id: row.id, name: row.name });
			this.costCenterToDelete = row;
		} else if (action === 'add') {
			let finalCode = '';
			if (row.children && row.children.length > 0) {
				const maxCode = Math.max(...row.children.map(child => parseInt(child.code, 10)));
				const newCode = String(maxCode + 1).padStart(2, '0');
				finalCode = `${row.code}.${newCode}`;
			} else {
				finalCode = `${row.code}.01`;
			}
			const newLevel = row.level + 1;
			this.goTo(COSTS_CENTERS_NEW,
				{ params: { fatherId: row.id, code: finalCode, level: newLevel }, query: this.$route.query });
		}
	}

	async function loadCostC() {
		const params = {
			sortDirection: 'ASC',
			flagHierarchy: 1,
		};
		try {
			const { data: response } = await this.$http.get(`cost-center/${this.currentSubsidiary.id}/subsidiary`, { params });
			this.costCenters = response;
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		}
	}

	async function onDelete() {
		this.loading = true;
		try {
			const body = {
				subsidiaryId: this.costCenterToDelete.subsidiaryId,
			};
			await this.$http.delete(`cost-center/${this.costCenterId}`, { data: body });
			this.showNotification('El centro de costos ha sido eliminado correctamente.');
			this.closeDialog();
			this.params.page = 1;
			this.currentPage = 1;
			this.loadCostC();
			this.costCenterToDelete = {};
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
		}
	}

	async function onSearchTable(value) {
		const newVal = value ? value.trim() : '';
		this.params.search = newVal || null;
		this.params.page = 1;
		this.currentPage = 1;
		this.loadCostC();
	}

	function openConfirmation({ id, name }) {
		this.costCenterId = id;
		this.dialogMessage = `¿Desea eliminar el centro de costos ${name} del listado?`;
		this.dialog = true;
	}

	function runAction({ codeWeb }) {
		if (codeWeb === COSTS_CENTERS_NEW || codeWeb === 'cost-center-import') {
			let finalCode = '';
			if (this.costCenters && this.costCenters.length > 0) {
				const maxCode = Math.max(...this.costCenters.map(row => parseInt(row.code, 10)));
				const newCode = String(maxCode + 1).padStart(2, '0');
				finalCode = `${newCode}`;
			} else {
				finalCode = '01';
			}
			this.goTo(codeWeb, { params: { code: finalCode, level: 1 }, query: this.$route.query });
		}
	}

	function title() {
		const { query, meta } = this.$route;
		return `${query.subsidiaryName} / ${meta.title}`;
	}

	function currentSubsidiary(newSubsidiary) {
		this.$loadCostCenter({ context: this, subsidiaryId: newSubsidiary.id });
	}

	function data() {
		return {
			columns: [
				{ id: 1, name: 'Código', value: 'code', checked: true, visible: true, movil: true },
				{ id: 2, name: 'Nombre', value: 'name', checked: true, visible: true, movil: true },
				{ id: 3, name: 'Cta. Contable', value: 'account', checked: true, visible: true, movil: true },
				{ id: 4, name: 'Acciones', checked: true, visible: true, flagVisible: true, movil: true },
			],
			costCenterId: null,
			currentPage: 1,
			dialog: false,
			dialogMessage: '',
			loading: false,
			subsidiaryId: null,
			costCenterToDelete: {},
			costCenters: [],
		};
	}

	export default {
		name: 'page-cost-center',
		components: {
			actionBar,
			costCenterList,
			appActions,
			backButtonRoute,
			appTooltipButton,
			treeTable,
		},
		computed: {
			...mapGetters('costCenter', [
				'getCostsCenters',
			]),
			...mapGetters('subsidiary', [
				'currentSubsidiary',
			]),
			title,
		},
		created,
		data,
		methods: {
			...mapActions('costCenter', {
				$loadCostCenter: 'loadCostCenter',
			}),
			changePage,
			closeDialog,
			onClickIcon,
			onDelete,
			onSearchTable,
			openConfirmation,
			runAction,
			loadCostC,
		},
		watch: {
			$route(newVal) {
				if (newVal) {
					if (newVal.name === COSTS_CENTERS) {
						this.$loadCostCenter({ context: this, subsidiaryId: this.currentSubsidiary.id });
						this.loadCostC();
					}
				}
			},
			currentSubsidiary,
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/cost-centers/page-cost-center.vue